export default __webpack_public_path__ + "static/messages-empty-state-d5fb6d1fca7fdc026d2d25af662afb4e.png";